import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8" }
const _hoisted_2 = { class: "m-auto" }
const _hoisted_3 = { class: "flex justify-between items-center pt-10" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex flex-col w-[400px]" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex justify-end pt-2" }
const _hoisted_9 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_12 = {
  colspan: "2",
  class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
}
const _hoisted_13 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_14 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_15 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_16 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right" }
const _hoisted_17 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right" }
const _hoisted_18 = { class: "px-2 bg-next-gray-md-dark relative hover:bg-next-orange hover:text-white" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex justify-end pt-2" }
const _hoisted_21 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_24 = {
  colspan: "2",
  class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"
}
const _hoisted_25 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_26 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_27 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark" }
const _hoisted_28 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right" }
const _hoisted_29 = { class: "px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right" }
const _hoisted_30 = { class: "px-2 bg-next-gray-md-dark relative hover:bg-next-orange hover:text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalProgetto = _resolveComponent("ModalProgetto")!
  const _component_ModalProjectFilter = _resolveComponent("ModalProjectFilter")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, {
        visible: _ctx.loading ||_ctx.listaProgettiBu.loading||_ctx.listaMyProgetti.loading
      }, null, 8, ["visible"]),
      _createVNode(_component_ModalProgetto, {
        onSaved: _ctx.onAddProgetto,
        visible: _ctx.visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event))
      }, null, 8, ["onSaved", "visible"]),
      _createVNode(_component_ModalProjectFilter, {
        class: "z-50",
        visible: _ctx.filtri_visible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtri_visible) = $event)),
        data_inizio_dal: _ctx.filtri.data_inizio_dal,
        "onUpdate:data_inizio_dal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtri.data_inizio_dal) = $event)),
        data_inizio_al: _ctx.filtri.data_inizio_al,
        "onUpdate:data_inizio_al": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtri.data_inizio_al) = $event)),
        data_fine_dal: _ctx.filtri.data_fine_dal,
        "onUpdate:data_fine_dal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtri.data_fine_dal) = $event)),
        data_fine_al: _ctx.filtri.data_fine_al,
        "onUpdate:data_fine_al": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtri.data_fine_al) = $event)),
        cliente: _ctx.filtri.cliente,
        "onUpdate:cliente": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtri.cliente) = $event)),
        azienda_gruppo: _ctx.filtri.azienda_gruppo,
        "onUpdate:azienda_gruppo": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filtri.azienda_gruppo) = $event)),
        stato: _ctx.filtri.stato,
        "onUpdate:stato": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filtri.stato) = $event)),
        progetti: true
      }, null, 8, ["visible", "data_inizio_dal", "data_inizio_al", "data_fine_dal", "data_fine_al", "cliente", "azienda_gruppo", "stato"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Switcher, {
              modelValue: _ctx.tab_show,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tab_show) = $event)),
              options: ['I miei progetti', 'Tutti i progetti'],
              class: "grow whitespace-nowrap mr-3"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                labelVisible: false,
                modelValue: _ctx.listaMyProgetti.search,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listaMyProgetti.search) = $event)),
                placeholder: "Cerca nei progetti"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filtri_visible = !_ctx.filtri_visible)),
                class: "pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"
              }),
              _withDirectives(_createElementVNode("p", {
                class: "cursor-pointer pl-3 font-bold text-next-atp",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.svuotaFiltri && _ctx.svuotaFiltri(...args)))
              }, "Svuota filtri", 512), [
                [_vShow, _ctx.hasFiltri]
              ])
            ])
          ]),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.visible=true)),
            class: "w-44 ml-3 py-2 px-4 m-0"
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode(" + Aggiungi ")
            ])),
            _: 1
          })
        ]),
        (!_ctx.tab_show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Paginator, {
                  class: "",
                  pagination: _ctx.listaMyProgetti.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5",
                  cols: _ctx.progettiCols,
                  "onUpdate:cols": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.progettiCols) = $event)),
                  rows: _ctx.listaMyProgetti.rows,
                  onOrderUpdate: _ctx.listaMyProgetti.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_0`,
                      fn: _withCtx((context) => [
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(["table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group", {open: c.expanded}]),
                          onClick: ($event: any) => (c.expanded=!c.expanded)
                        }, _cache[17] || (_cache[17] = [
                          _createElementVNode("i", { class: "fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out" }, null, -1)
                        ]), 10, _hoisted_10), [
                          [_vShow, context.context.row.sottoprogetti.length != 0]
                        ]),
                        _createTextVNode(" " + _toDisplayString(context.context.row.id_gamma), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_8`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioProgetto', params:{id:context.context.row.id}},
                          class: "text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, j) => {
                    return {
                      name: `td_${j}_9`,
                      fn: _withCtx(() => [
                        _createVNode(_component_TabellaContextMenu, {
                          menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                          buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                          context: c,
                          id: j,
                          teleport_to: "#modal",
                          cmOpener: _ctx.cmOpener
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {name:'Attivita', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Attività ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            _createVNode(_component_router_link, {
                              to: {name:'Contatti', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("Contatti ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1032, ["context", "id", "cmOpener"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaMyProgetti.rows, (c, i) => {
                    return {
                      name: `td_child_${i}`,
                      fn: _withCtx((context) => [
                        (c.expanded)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(context.context.row.sottoprogetti_from_view, (cc, j) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: j,
                                class: "h-11.5 text-sm"
                              }, [
                                _createElementVNode("td", _hoisted_11, _toDisplayString(cc.cod_nodo), 1),
                                _createElementVNode("td", _hoisted_12, _toDisplayString(cc.titolo), 1),
                                _createElementVNode("td", _hoisted_13, _toDisplayString(context.context.row.denominazione), 1),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$filters.toDate(cc.data_inizio)), 1),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$filters.toDate(cc.data_fine)), 1),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$filters.toEuroCurrency(cc.budget)), 1),
                                _createElementVNode("td", _hoisted_17, _toDisplayString(cc.stato_next_descrizione), 1),
                                _createElementVNode("td", _hoisted_18, [
                                  _createVNode(_component_router_link, {
                                    to: {name:'DettaglioSottoProgetto', params:{id:cc.id}},
                                    class: "text-center inset-0 absolute flex items-center justify-center"
                                  }, {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaMyProgetti.fetchNextPage,
                identifier: _ctx.listaMyProgetti.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri progetti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Paginator, {
                  class: "",
                  pagination: _ctx.listaProgettiBu.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5",
                  cols: _ctx.progettiCols,
                  "onUpdate:cols": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.progettiCols) = $event)),
                  rows: _ctx.listaProgettiBu.rows,
                  onOrderUpdate: _ctx.listaProgettiBu.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_0`,
                      fn: _withCtx((context) => [
                        (context.context.row.sottoprogetti.length != 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group", {open: c.expanded}]),
                              onClick: ($event: any) => (c.expanded=!c.expanded)
                            }, _cache[23] || (_cache[23] = [
                              _createElementVNode("i", { class: "fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out" }, null, -1)
                            ]), 10, _hoisted_22))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(context.context.row.id_gamma), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_8`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioProgetto', params:{id:context.context.row.id}},
                          class: "block text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, j) => {
                    return {
                      name: `td_${j}_9`,
                      fn: _withCtx(() => [
                        _createVNode(_component_TabellaContextMenu, {
                          menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                          buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                          context: c,
                          id: j,
                          teleport_to: "#modal",
                          cmOpener: _ctx.cmOpener
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {name:'Attivita', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createTextVNode("Attività ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            _createVNode(_component_router_link, {
                              to: {name:'Contatti', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[26] || (_cache[26] = [
                                _createTextVNode("Contatti ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1032, ["context", "id", "cmOpener"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaProgettiBu.rows, (c, i) => {
                    return {
                      name: `td_child_${i}`,
                      fn: _withCtx((context) => [
                        (c.expanded)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(context.context.row.sottoprogetti_from_view, (cc, j) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: j,
                                class: "h-11.5 text-sm"
                              }, [
                                _createElementVNode("td", _hoisted_23, _toDisplayString(cc.cod_nodo), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(cc.titolo), 1),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(context.context.row.denominazione), 1),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$filters.toDate(cc.data_inizio)), 1),
                                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$filters.toDate(cc.data_fine)), 1),
                                _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$filters.toEuroCurrency(cc.budget)), 1),
                                _createElementVNode("td", _hoisted_29, _toDisplayString(cc.stato_next_descrizione), 1),
                                _createElementVNode("td", _hoisted_30, [
                                  _createVNode(_component_router_link, {
                                    to: {name:'DettaglioSottoProgetto', params:{id:cc.id}},
                                    class: "block text-center inset-0 absolute flex items-center justify-center"
                                  }, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaProgettiBu.fetchNextPage,
                identifier: _ctx.listaProgettiBu.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri progetti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}